import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  const includes = [{
    name: 'Ebook RENACIDA',
    price: '$47'
  }, {
    name: 'Bono · Manual de Intimidad Post-Bebé',
    price: '$27'
  }, {
    name: 'Bono · Mamá Sin Inflamación',
    price: '$27'
  }, {
    name: 'Bono · Dormir en Crisis',
    price: '$27'
  }];
  return <Section className="py-20" data-id="element-33">
      <div className="max-w-4xl mx-auto text-center" data-id="element-34">
        <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-35">
          Llevas demasiado tiempo poniendo a todos antes que a ti misma.
        </h2>
        <p className="text-xl text-brown-light mb-12" data-id="element-36">
          A tu bebé. A tu pareja. A tu familia.
          <br data-id="element-37" />
          <span className="font-serif italic text-rose-dark text-2xl mt-4 block" data-id="element-38">
            Hoy es tu turno.
          </span>
        </p>

        <p className="text-lg font-medium mb-8" data-id="element-39">Tienes dos opciones:</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-40">
          <div className="bg-white p-8 rounded-2xl border border-cream-dark shadow-sm opacity-70" data-id="element-41">
            <h3 className="font-serif text-xl mb-4 text-brown-light" data-id="element-42">
              Opción 1
            </h3>
            <p className="text-brown-light" data-id="element-43">
              Seguir aguantando el agotamiento, la hinchazón y el vacío
              esperando que "se pase solo".
            </p>
          </div>

          <div className="bg-rose/5 p-8 rounded-2xl border-2 border-rose/30 shadow-md relative overflow-hidden" data-id="element-44">
            <div className="absolute top-0 right-0 w-24 h-24 bg-brush-rose rounded-full blur-xl -mr-10 -mt-10" data-id="element-45"></div>
            <h3 className="font-serif text-xl mb-4 text-rose-dark font-semibold" data-id="element-46">
              Opción 2
            </h3>
            <p className="text-brown-dark relative z-10" data-id="element-47">
              Tomar la decisión más poderosa que puedes tomar hoy como mujer y
              como mamá. Invertir en tu recuperación, en tu bienestar y en tu
              regreso a ti misma.
            </p>
          </div>
        </div>

        {/* Pricing card */}
        <div className="relative bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-rose/20 mb-10 text-left overflow-hidden" data-id="element-48">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brush-rose rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-49"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brush-sage rounded-full blur-3xl opacity-40 pointer-events-none" data-id="element-50"></div>

          <div className="relative z-10" data-id="element-51">
            <p className="text-center text-sm uppercase tracking-widest text-rose-dark font-semibold mb-2" data-id="element-52">
              Tu paquete completo de transformación
            </p>
            <h3 className="text-center font-serif text-2xl md:text-3xl text-brown-dark mb-8" data-id="element-53">
              Todo lo que recibes hoy
            </h3>

            <ul className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-54">
              {includes.map((item, i) => <li key={i} className="flex items-center justify-between gap-4 pb-3 border-b border-cream-dark last:border-b-0" data-id="element-55">
                  <span className="flex items-start gap-3 text-brown-dark" data-id="element-56">
                    <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-57" />
                    <span data-id="element-58">{item.name}</span>
                  </span>
                  <span className="text-brown-light text-sm" data-id="element-59">{item.price}</span>
                </li>)}
            </ul>

            <div className="max-w-md mx-auto bg-cream-light rounded-2xl p-6 text-center mb-8" data-id="element-60">
              <p className="text-sm uppercase tracking-wider text-brown-light mb-2" data-id="element-61">
                Valor total
              </p>
              <p className="text-3xl font-serif line-through text-brown-light/60 mb-4" data-id="element-62">
                $128
              </p>
              <p className="text-sm uppercase tracking-wider text-rose-dark font-semibold mb-2" data-id="element-63">
                Tu precio hoy
              </p>
              <p className="text-5xl md:text-6xl font-serif font-bold text-rose-dark" data-id="element-64">
                $7.<span className="text-3xl md:text-4xl align-top" data-id="element-65">99</span>
              </p>
              <p className="text-sm text-brown-light mt-3 italic" data-id="element-66">
                Pago único · Acceso inmediato
              </p>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-67">
              <Button className="w-full sm:w-auto text-lg px-10 py-5 shadow-lg shadow-rose/20" data-id="element-68">
                🦋 Sí, quiero todo por $7.99
              </Button>
              <p className="text-sm text-brown-light text-center" data-id="element-69">
                Haz clic aquí y comienza tu recuperación posparto hoy
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-rose/20" data-id="element-70">
          <p className="text-3xl font-serif text-brown-dark" data-id="element-71">
            Porque diste vida.
            <br data-id="element-72" />
            <span className="italic text-rose-dark mt-2 block" data-id="element-73">
              Y ahora mereces recuperar la tuya. 🌸
            </span>
          </p>
        </div>
      </div>
    </Section>;
}